/* eslint-disable */
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Smart Watch South Africa',
        title: 'Buisness Owner',
        text: "Hi Amarjeet thank you so much for the fantastic service you have given me I appreciate your efforts and making sure all my settings are functional and ready to go.",
        image: boy2
    },
    {
        id: 2,
        name: 'Aklasu',
        title: 'Tech Support',
        text: "Richpanel is exactly was I was looking for when it comes to CRM. Support has been excellent. I had an issue, and Amarjeet set up a Zoom call to work through it. The app seems very well built and thought out.",
        image: boy1
    },
    // {
    //     id: 3,
    //     name: 'Phoebe Buffay',
    //     title: 'Massuese',
    //     text: "Heard of the song 'Smelly Cat!!' ? This website made it viral. Plus portfolio is the only thing that Ursula doesn't have :)",
    //     image: girl1
    // },
    // {
    //     id: 4,
    //     name: 'Joey Tribbiani',
    //     title: 'Actor',
    //     text: "Making my portfolio with this helped me get my role as 'Dr. Drake Ramoray' in 'Days Of Our Lives'. You guys are the best !",
    //     image: boy1
    // },
    // {
    //     id: 5,
    //     name: 'Rachel Green',
    //     title: 'Sales Executive',
    //     text: 'Ralph Lauren was one of the best things that ever happened to me. My portfolio made that dream happen. I owe you guys.',
    //     image: girl3
    // },
    // {
    //     id: 6,
    //     name: 'Ross Geller',
    //     title: 'Paleontologist',
    //     text: "Be it 'Rocks' or 'Bones', you need a website to display it. This is it. Great work guys !",
    //     image: boy3
    // }
]

